export const SN_PRODUCTS = 'PRODUCTS'
export const SET_PRODUCTS = `${SN_PRODUCTS}/SET_PRODUCTS`
export const SET_PRODUCT = `${SN_PRODUCTS}/SET_PRODUCT`
export const SET_RELEASED_PRODUCTS = `${SN_PRODUCTS}/SET_RELEASED_PRODUCTS`
